import * as React from "react";
const SvgCircularEuro = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    />
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M11.332 12.972c-.607 1.417-1.518 2.835-2.733 3.402h5.77s.912 0 1.52-.567m-2.43-2.835H8.112m6.803-2.673a2.673 2.673 0 1 0-2.673 2.673"
    />
  </svg>
);
export default SvgCircularEuro;
